module.exports = __webpack_public_path__ + "images/emoji/clock630.26b1998bcaee753346b9.png";